// Converts Persian (۰۱۲۳۴۵۶۷۸۹) & Arabic-Indic (٠١٢٣٤٥٦٧٨٩) digits to ASCII 0-9
const toEnglishDigits = (str = "") =>
  String(str)
    .replace(/[۰-۹]/g, d => String("۰۱۲۳۴۵۶۷۸۹".indexOf(d)))
    .replace(/[٠-٩]/g, d => String("٠١٢٣٤٥٦٧٨٩".indexOf(d)));

export default toEnglishDigits;
